import Vue from 'vue'
import VueX from 'vuex'
import request from '../utils/request'
Vue.use(VueX)

export default new VueX.Store({
  state: {
    token: sessionStorage.getItem('token'),
    playVisible: false,
    activeIndex: '/home',
    answerVisible: false,
    jurisdictionVideo: true,
    studentInf: [],   // 学员信息
    studentShow: false,  // 是否获取到学院信息
  },
  getters: {
    getToken: state => state.token,
    studentInf: state => state.studentInf,
    studentShow: state => state.studentShow
  },
  mutations: {
    setPlayVisible (state, value) {
      state.playVisible = value
    },
    setActiveIndex (state, value) {
      state.activeIndex = value
    },
    setAnswerVisible (state, value) {
      state.answerVisible = value
    },
    setJurisdictionVideo (state, value) {
      // 判断页面播放是否进行了人脸验证，默认验证成功
      state.jurisdictionVideo = value
    },
    setStudentInf (state, value) {
      state.studentInf = value
    },
    setStudentShow (state, value) {
      state.studentShow = value
    }
  },
  actions: {
    // 资格核验
    verification ({commit}, user) {
      let that = this
      request({
        method: 'POST',
        url: '/api/renren-fast/app/zxpxjp/zxpx_01',
        data: {
          'coupon': {
            "aca111": user ? user.aca111 : '',       // 课程编号
            "aca112": user ? user.aca112 : '',      // 课程名称
            "aca11a": user ? user.aca11a : '',      // 等级
            "couponcode": user ? user.couponcode : '',   // 身份证号
            "couponname": user ? user.couponname : ''    // 姓名
          }
        }
      }).then((result) => {
        console.log(result)
        if (result.data.code === 0) {

        } else {
          that.$message.error(result.data.msg)
        }
      })
    },
    studentInformation ({commit, dispatch}) {
      let that = this
      request({
        method: 'GET',
        url: '/api/renren-fast/app/zxpxjp/zxpx_03'
      }).then((result) => {
        console.log(result)
        if (result.data.code === 0) {
          commit('setStudentInf', result.data.data)
          commit('setStudentShow', true)
          dispatch('verification', result.data.data[0])
        } else {
          that.$message.error(result.data.msg)
        }
      })
    }

  }
})



// WEBPACK FOOTER //
// ./src/store/store.js